var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',{staticClass:"my-0 px-2 pb-0 pt-0 border-l-4 border-solid border-slate-75 dark:border-slate-600 text-slate-600 dark:text-slate-200"},[_c('span',[_vm._v(_vm._s(_vm.$t('CONVERSATION.REPLIED_TO_STORY')))]),_vm._v(" "),_c('instagram-story',{staticClass:"mt-3 rounded-md",attrs:{"story-url":_vm.storyUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }